import React, { useEffect, useRef, useState } from 'react'
import {
  useLoadScript,
  GoogleMap,
  useGoogleMap,
  Marker
} from '@react-google-maps/api'

const mapOptions = {
  fullscreenControl: false,
  disableDefaultUI: true,
  panControl: true,
  zoomControl: true,
}

const mapStyles = {
  height: '300px',
}

// Determine the bound of indonesia
// This value picked manually, you can freely adjust this value
const indonesiaBound = {
  northEast: {
    lat: 4.463729,
    lng: 140.990397
  },
  southWest: {
    lat: -9.756614,
    lng: 95.582856
  },
}

/**
 * Set Initial Map Bound
 */
const SetMapBound = () => {
  const maps = useGoogleMap()

  // Set initial map bound
  useEffect(() => {
    if (maps) {
      // eslint-disable-next-line no-undef
      const bounds = new google.maps.LatLngBounds()
      bounds.extend(indonesiaBound.northEast)
      bounds.extend(indonesiaBound.southWest)
      maps.fitBounds(bounds)
    }
  }, [maps])

  return null
}

/**
 * Map Search Box
 */
const MapSearchBox = ({ onPlaceChanged }) => {
  const maps = useGoogleMap()
  const inputEl = useRef(null)

  const onKeypress = (e) => {
    // On enter pressed
    if (e.key === 'Enter') {
      e.preventDefault()
      return false
    }
  }

  useEffect(() => {
    if (maps && inputEl.current) {
      // eslint-disable-next-line no-undef
      const autocomplete = new google.maps.places.Autocomplete(inputEl.current)
      autocomplete.bindTo('bounds', maps)
      autocomplete.setFields(['address_components', 'icon', 'name', 'geometry'])

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace()

        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
          maps.fitBounds(place.geometry.viewport);
        } else {
          maps.setCenter(place.geometry.location);
          maps.setZoom(17);  // Why 17? Because it looks good.
        }

        onPlaceChanged(place)
      })
    }
  }, [maps, inputEl, onPlaceChanged])

  return (
    <div className="absolute m-5 w-full pr-10 lg:pr-0 lg:w-1/2">
      <input
        ref={inputEl}
        type="text"
        className="rounded border py-2 px-4 text-sm w-full"
        placeholder="Find Address"
        style={{borderColor: '#ddd'}}
        onKeyPress={onKeypress}
      />
    </div>
  )
}

const scriptOptions = {
  googleMapsApiKey: 'AIzaSyDUzzFb6xuDVMK0zHYTqsqkIsESP0TG5v0',
  libraries: ['places'],
}

/**
 * The Map Component
 */
const PinPointInput = ({ onPlaceSet }) => {
  const [marker, setMarker] = useState(false)
  const { isLoaded, loadError } = useLoadScript(scriptOptions)

  const onPlaceChanged = (place) => {
    setMarker(place.geometry.location.toJSON())
    onPlaceSet(place)
  }

  const renderMap = () => {
    return (
      <GoogleMap
        options={mapOptions}
        mapContainerStyle={mapStyles}
      >
        <SetMapBound />
        <MapSearchBox onPlaceChanged={onPlaceChanged} />
        { marker && <Marker position={marker} /> }
      </GoogleMap>
    )
  }

  if (loadError) {
    return <div>Map cannot be loaded right now</div>
  }

  return isLoaded ? renderMap() : <div className="bg-gray-200">Loading...</div>
}

PinPointInput.defaultProps = {
  onPlaceSet: () => {},
}

export { PinPointInput }
